export enum DocumentFileTypePrivateLeaseEnum {
  bankStatement = 'bankStatement',
  savingsBankAccountStatement = 'savingsBankAccountStatement',
  payslip = 'payslip',
  contractofEmployment = 'contractofEmployment',
  sourceofFunds = 'sourceofFunds',
  other = 'other',
}

export enum DocumentFileTypeOperatingLeaseEnum {
  financialAccounts = 'financialAccounts',
  financialStatementPreviousYear = 'financialStatementPreviousYear',
  bankStatement = 'bankStatement',
  managementAccounts = 'managementAccounts',
  selfEmployedDocument = 'selfEmployedDocument',
  other = 'other',
}

export type DocumentFileType = DocumentFileTypePrivateLeaseEnum | DocumentFileTypeOperatingLeaseEnum;

export interface UploadedFileModel {
  id: string;
  filename: string;
  size: number;
  isUploaded: boolean;
  isFileValid: boolean; // Is file has metadata
  mimeType: string;
  metadata?: {
    type?: DocumentFileType;
  };
}
